<template>
  <div :class="['definition-wrapper', 'text', definition.id, {'error_validate': (mandatoryValidation || validation) && !focused }, {'ok_validate': !mandatoryValidation && !validation && textValue && !focused}]">
    <div v-if="editable" :class="[{'multilanguageText': isMultiLanguage(), 'languageText': !isMultiLanguage(), 'translation': isForTranslate() || isForCopy() }]">
      <input :placeholder="placeholder" v-if="definition.type === 'text'" type="text" v-model="textValue" ref="inputText" :name="definition.id" @blur="getBlur($event)" @focus="setFocus()" @keyup="keyPressed($event)" class="w3-input" :maxlength="lengthMax">
      <!-- Editor JS (CodeMirror 6 + prettify) — se activa cuando el visual del campo longText lleva el token de clase `js-code` -->
      <div v-else-if="isJsCodeEditor" class="js-code">
        <div class="js-code-toolbar">
          <button type="button" class="js-code-format-btn" @click="prettifyCode" :title="formatLabel">
            <i class="fa fa-magic"></i> {{ formatLabel }}
          </button>
        </div>
        <div ref="cmHost" class="js-code-editor" :class="{'error_validate': (mandatoryValidation || validation) && !focused}"></div>
      </div>
      <textarea :placeholder="placeholder" v-else-if="definition.type === 'longText'" v-model="textValue" ref="textarea" :name="definition.id" @blur="getBlur($event)" @focus="setFocus()" class="w3-input" :maxlength="lengthMax"></textarea>
      <span v-if="messageCountCharacters" id="count" class="w3-right count" v-text="messageCountCharacters"></span>
      <!-- emoji pickers -->
      <transition name="fade" mode="out-in">
        <picker v-if="isIconSet()" v-show="emojiShow"
          emoji="question"
          :set="emojiSet"
          :title="getLang('emojiSelect')"
          :sheetSize="emojiSheetSize"
          :i18n="emojiI18n"
          :style="{ position: 'absolute', top: '38px', right: '0', 'z-index': '1000', border: '1px solid #ccc' }"
          @select="addEmoji"
        />
      </transition>
      <div v-if="isIconSet()" :class="['emoji-invoker', {'active': emojiShow}]">
        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" v-on:click="emojiShow = !emojiShow">
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
        </svg>
      </div>
      <svg v-if="(mandatoryValidation || validation) && !focused" class="validation_icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2544 11.5L7.99669 1.45935C7.80248 1.08875 7.41863 0.856537 7.00022 0.856537C6.58181 0.856537 6.19796 1.08875 6.00375 1.45935L0.745501 11.5C0.56282 11.8487 0.575751 12.2676 0.779598 12.6045C0.983444 12.9413 1.34854 13.147 1.74225 13.147H12.2576C12.6513 13.147 13.0164 12.9413 13.2203 12.6045C13.4241 12.2676 13.4371 11.8487 13.2544 11.5ZM6.43744 4.98794C6.43744 4.67728 6.68928 4.42544 6.99994 4.42544C7.3106 4.42544 7.56244 4.67728 7.56244 4.98794V8.36294C7.56244 8.6736 7.3106 8.92544 6.99994 8.92544C6.68928 8.92544 6.43744 8.6736 6.43744 8.36294V4.98794ZM7.01231 11.4623H7.02806C7.25143 11.4587 7.46391 11.3652 7.61742 11.2029C7.77093 11.0406 7.8525 10.8232 7.84369 10.6C7.82558 10.1395 7.44729 9.77535 6.98644 9.7748H6.97069C6.74787 9.77888 6.53605 9.87236 6.38287 10.0342C6.22968 10.1961 6.148 10.4127 6.15619 10.6354C6.17368 11.096 6.55139 11.4608 7.01231 11.4623Z" fill="#FF3654"/>
      </svg>
      <svg v-else-if="textValue && !focused" class="validation_icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.25 7C0.25 3.27208 3.27208 0.25 7 0.25C10.7261 0.25434 13.7457 3.27388 13.75 7C13.75 10.7279 10.7279 13.75 7 13.75C3.27208 13.75 0.25 10.7279 0.25 7ZM7.04612 10.0876L10.8964 4.8625C11.0266 4.70139 11.0577 4.48179 10.9774 4.29087C10.8971 4.09996 10.7183 3.96863 10.5121 3.94902C10.306 3.92942 10.1057 4.02471 9.99081 4.19706L6.48812 8.95075L4.19537 7.11644C3.95275 6.92228 3.59866 6.96156 3.4045 7.20419C3.21034 7.44681 3.24962 7.8009 3.49225 7.99506L6.24175 10.1933C6.36195 10.2873 6.51485 10.329 6.66611 10.3091C6.81737 10.2892 6.9543 10.2094 7.04612 10.0876Z" fill="#13BD38"/>
      </svg>
    </div>
    <definition-read-only v-else :definitionId="definitionId" :definition="definition" :object="object" :languageSelected="languageSelected" :visualDefinition="visualDefinition" :language="language" />
    <div v-if="isMultiLanguage() && showMultilanguage" :class="['languageSelectorOrTask']">
      <definition-multilanguage
        :definition="definition" :object="object" :languageSelected="languageSelected" :translating="translating" :language="language" :apiparams="apiparams"
        @newLanguageSelected="newLanguageSelected" @translate="translate" @copy="copy"
      />
    </div>
    <definition-task v-if="definition.task && definition.task.length > 0 && (editable || definition.type === 'id')"
      class="w3-col" :definition="definition" :object="object" :definitionObject="definitionObject" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams" :callTask="callTask"
      @refreshDefinition="taskValueChanged" @refreshDefinitionContent="refreshDefinitionContent" @taskLink="taskLink" @taskEnded="taskEnded"
    />
  </div>
</template>

<script>
import DefinitionReadOnly from './readOnly'
import DefinitionMultilanguage from './multilanguage'
import DefinitionTask from './task'
import transport from 'vue-definition-utils/src/utils/transport'
import moment from 'moment'
// Editor JS para campos longText marcados con la clase visual `js-code`
import { EditorView, basicSetup } from 'codemirror'
import { keymap } from '@codemirror/view'
import { indentWithTab } from '@codemirror/commands'
import { javascript } from '@codemirror/lang-javascript'
import { Picker } from 'emoji-mart-vue' // comment for 'definition.js' low size
import language from '../language'
import translate from '../utils/translate'

export default {
  name: 'definition-text',
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'languageSelected',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'showMultilanguage',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'authorization',
    'type',
    'visuals',
    'visualDefinition',
    'apiparams',
    'placeholder',
    'callTask',
    'isFocus',
    'isPassword'
  ],
  components: {
    Picker, // comment for 'definition.js' low size
    DefinitionReadOnly,
    DefinitionMultilanguage,
    DefinitionTask
  },
  data () {
    return {
      textValue: '',
      validation: null,
      lengthMax: 0,
      countTextLength: 0,
      translating: false,
      emojiShow: false,
      emojiSet: '',
      emojiSheetSize: 32,
      emojiI18n: {
        search: this.getLang('emojiSearch'),
        notfound: this.getLang('emojiNotfound'),
        categories: {
          search: this.getLang('emojiCategoriesSearch'),
          recent: this.getLang('emojiCategoriesRecent'),
          people: this.getLang('emojiCategoriesPeople'),
          nature: this.getLang('emojiCategoriesNature'),
          foods: this.getLang('emojiCategoriesFoods'),
          activity: this.getLang('emojiCategoriesActivity'),
          places: this.getLang('emojiCategoriesPlaces'),
          objects: this.getLang('emojiCategoriesObjects'),
          symbols: this.getLang('emojiCategoriesSymbols'),
          flags: this.getLang('emojiCategoriesFlags'),
          custom: this.getLang('emojiCategoriesCustom')
        }
      },
      focused: false,
      cmView: null
    }
  },
  mounted () {
    if (this.isJsCodeEditor) {
      this.initCodeMirror()
      return
    }
    if (this.isFocus) {
      if (this.definition.type === 'text' && this.$refs.inputText) {
        this.$refs.inputText.focus()
      } else if (this.definition.type === 'longText' && this.$refs.textarea) {
        this.$refs.textarea.focus()
      }
    }
  },
  beforeUnmount () {
    if (this.cmView) {
      this.cmView.destroy()
      this.cmView = null
    }
  },
  methods: {
    getBlur (event) {
      this.focused = false
      this.valueChanged(event)
    },
    // 1.1. Launch validate mandatory event on blur
    valueChanged (event) {
      this.setObjectTextValue()
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    // 1.2. Launch validate mandatory event on Enter pressed
    keyPressed (event) {
      if (event.key === 'Enter') {
        this.$refs.inputText.blur()
        this.valueChanged(event)
      }
    },
    validateTextFormat () {
      var formatAndRequired = this.getFormatAndRequired()
      var format = formatAndRequired.format
      var isRequired = formatAndRequired.isRequired

      this.validation = transport.methods.validateTextFormat(isRequired, format, this.textValue)
      // 3. if text format validation past...
      if (this.validation === null) {
        // ... launch refresh definition event
        this.$emit('refreshDefinition', this.object)
      } else {
        // ... or launch text format error event to show error message
        this.$emit('textFormatError', moment().valueOf(), this.validation, format)
      }
    },
    isMultiLanguage () {
      return transport.methods.isMultiLanguage(this.definition)
    },
    taskValueChanged (object) {
      if (this.isMultiLanguage()) {
        this.textValue = transport.methods.getLanguageValue(object, this.languageSelected.key)
      } else {
        this.textValue = object.textValue
      }
      this.setObjectTextValue()
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    taskLink (obj) {
      this.$emit('taskLink', obj)
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    setObjectTextValue () {
      if (this.isMultiLanguage()) {
        const updatedObject = transport.methods.setLanguageValue(this.object, this.textValue, this.languageSelected.key)
        Object.assign(this.object, updatedObject)
      } else {
        this.object.textValue = this.textValue
      }
    },
    setTextValue (languageSelected) {
      if (this.object) {
        if (!this.isMultiLanguage()) {
          this.textValue = this.object.textValue
        } else if (languageSelected) {
          this.setLanguageTextValue(languageSelected)
        }
      }
    },
    setLanguageTextValue (languageSelected) {
      this.textValue = transport.methods.getLanguageValue(this.object, languageSelected.key)
      var language = transport.methods.getLanguage(languageSelected.key, this.definition)
      this.setCountTextLength(language.format)
      this.$nextTick(() => {
        if (this.$refs.inputText) this.$refs.inputText.value = this.textValue || ''
        if (this.$refs.textarea) this.$refs.textarea.value = this.textValue || ''
      })
    },
    setCountTextLength (languageSelected) {
      var formatAndRequired = this.getFormatAndRequired()
      var format = formatAndRequired.format
      if (format) {
        this.lengthMax = format.lengthMax
        var textValueLength = 0
        if (this.textValue) {
          textValueLength = this.textValue.length
        }
        this.countTextLength = this.lengthMax - textValueLength
      }
    },
    isIconSet () {
      var result = false
      var formatAndRequired = this.getFormatAndRequired()
      var format = formatAndRequired.format
      if (format) {
        if (format.iconSet && format.iconSet !== '') {
          this.emojiSet = format.iconSet
          result = true
        }
      }
      return result
    },
    getFormatAndRequired () {
      var result = {
        format: null,
        isRequired: false
      }
      if (this.isMultiLanguage() && this.languageSelected) {
        var language = transport.methods.getLanguage(this.languageSelected.key, this.definition)
        if (language) {
          result.format = language.format
          result.isRequired = language.mandatory
        }
      } else {
        result.format = this.definition.validation.format
        result.isRequired = transport.methods.isRequired(this.definition)
      }
      return result
    },
    addEmoji (emoji) {
      this.textValue += emoji.native
      this.setObjectTextValue()
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    getLang (key, params, values) {
      return language(this.language, key, params, values)
    },
    // -- Editor JS (CodeMirror 6) --------------------------------------------
    initCodeMirror () {
      if (this.cmView || !this.$refs.cmHost) {
        return
      }
      const self = this
      this.cmView = new EditorView({
        doc: this.textValue || '',
        extensions: [
          basicSetup,
          javascript(),
          keymap.of([indentWithTab]),
          EditorView.lineWrapping,
          EditorView.editable.of(!!this.editable),
          EditorView.updateListener.of((v) => {
            if (v.docChanged) {
              const value = self.cmView.state.doc.toString()
              if (value !== self.textValue) {
                self.textValue = value
                self.setObjectTextValue()
              }
            }
          })
        ],
        parent: this.$refs.cmHost
      })
    },
    // Sincroniza un valor externo (carga GET, prettify) hacia el editor sin bucle.
    syncCodeMirror (value) {
      if (this.cmView && this.cmView.state.doc.toString() !== (value || '')) {
        this.cmView.dispatch({
          changes: { from: 0, to: this.cmView.state.doc.length, insert: value || '' }
        })
      }
    },
    // Formatea (prettify) el código JS pegado. Prettier se carga bajo demanda.
    async prettifyCode () {
      const source = this.cmView ? this.cmView.state.doc.toString() : (this.textValue || '')
      try {
        const prettier = await import('prettier/standalone')
        const babelPlugin = await import('prettier/plugins/babel')
        const estreePlugin = await import('prettier/plugins/estree')
        const formatted = await prettier.format(source || '', {
          parser: 'babel',
          plugins: [babelPlugin.default || babelPlugin, estreePlugin.default || estreePlugin],
          semi: true,
          singleQuote: true,
          tabWidth: 2
        })
        const clean = formatted.replace(/\n$/, '')
        this.syncCodeMirror(clean)
        this.textValue = clean
        this.setObjectTextValue()
        this.$emit('validateMandatory', moment().valueOf(), this.object)
      } catch (e) {
        // Código con error de sintaxis: no se formatea, se deja tal cual.
        console.warn('No se pudo formatear el código JS:', e && e.message ? e.message : e)
      }
    },
    translate (fromLanguage) {
      if (this.textValue.trim() !== '' && this.isMultiLanguage() && this.object.languageValue && this.object.languageValue.length > 1) {
        this.translating = true
        var self = this
        setTimeout(function () {
          self.translateLanguage(fromLanguage, 0, self.object.languageValue)
        }, 500)
      }
    },
    translateLanguage (fromLanguage, index, languages) {
      if (index < languages.length) {
        var language = this.object.languageValue[index]
        if (language.key !== fromLanguage.key && language.value.trim() === '') {
          translate(
            this.apiparams.translateUrl,
            this.apiparams.translateKey,
            this.textValue,
            fromLanguage.key,
            language.key
          )
            .then(translation => {
              this.object = transport.methods.setLanguageValue(this.object, translation.translatedText, translation.targetLang)
              this.translateLanguage(fromLanguage, ++index, languages)
            })
            .catch(err => {
              console.error(err)
              this.translating = false
            })
        }
        this.translateLanguage(fromLanguage, ++index, languages)
      } else {
        var self = this
        setTimeout(function () {
          self.translating = false
          self.$emit('validateMandatory', moment().valueOf(), self.object)
        }, 200)
      }
    },
    copy (fromLanguage) {
      if (this.textValue.trim() !== '' && this.isMultiLanguage() && this.object.languageValue && this.object.languageValue.length > 1) {
        this.translating = true
        var self = this
        setTimeout(function () {
          self.copyLanguage(fromLanguage, 0, self.object.languageValue)
        }, 500)
      }
    },
    copyLanguage (fromLanguage, index, languages) {
      if (index < languages.length) {
        var language = languages[index]
        if (language.key !== fromLanguage.key && language.value.trim() === '') {
          const updatedObject = transport.methods.setLanguageValue(this.object, this.textValue, language.key)
          Object.assign(this.object, updatedObject)
        }
        this.copyLanguage(fromLanguage, ++index, languages)
      } else {
        var self = this
        setTimeout(function () {
          self.translating = false
          self.$emit('validateMandatory', moment().valueOf(), self.object)
        }, 200)
      }
    },
    isForTranslate () {
      return transport.methods.isForTranslate(this.definition, this.apiparams)
    },
    isForCopy () {
      return transport.methods.isForCopy(this.definition)
    },
    setFocus () {
      this.$nextTick(() => {
        this.focused = true
      })
    },
    taskEnded (result) {
      this.$emit('taskEnded', result)
    }
  },
  beforeMount () {
    this.setTextValue(this.languageSelected)
    this.setCountTextLength(this.languageSelected)
  },
  computed: {
    messageCountCharacters () {
      return this.getLang('remainCharacters', ['count', 'maxLength'], [this.countTextLength, this.lengthMax])
    },
    // Cierto si el visual del campo (aliasExceptions → class) lleva el token `js-code`.
    isJsCode () {
      try {
        if (this.visualDefinition && typeof this.visualDefinition.getDefinitionFields === 'function') {
          var presentation = this.visualDefinition.getDefinitionFields(this.definition)
          if (presentation && presentation.class) {
            return presentation.class.split(' ').indexOf('js-code') !== -1
          }
        }
      } catch (e) {}
      return false
    },
    // El editor JS sustituye al textarea solo en campos longText marcados js-code.
    isJsCodeEditor () {
      return this.editable && this.definition.type === 'longText' && this.isJsCode
    },
    formatLabel () {
      var labels = { ca: 'Formatar', es: 'Formatear', en: 'Format' }
      var iso = (this.language && this.language.isoCode) ? this.language.isoCode : 'ca'
      return labels[iso.substring(0, 2)] || 'Format'
    }
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (value.validateKey === null || value.validateKey.trim() === '')) {
        // ... launch text format validation
        this.validateTextFormat()
      }
    },
    languageSelected (languageSelected) {
      if (this.isMultiLanguage()) {
        this.setLanguageTextValue(languageSelected)
        this.setCountTextLength(languageSelected)
      }
    },
    object: {
      handler (object) {
        this.$nextTick(() => {
          this.setTextValue(this.languageSelected)
        })
      },
      deep: true
    },
    textValue (textValue) {
      this.setCountTextLength(this.languageSelected)
      this.$emit('textValueLength', textValue)
      // Refleja en el editor JS los cambios de valor externos (carga GET, prettify).
      if (this.cmView) {
        this.syncCodeMirror(textValue)
      }
    },
    // Si el campo pasa a ser js-code tras cargar la definición de forma asíncrona.
    isJsCodeEditor (active) {
      if (active && !this.cmView) {
        this.$nextTick(() => {
          this.initCodeMirror()
        })
      }
    }
  },
  directives: {
    focus: {
      inserted (el) {
        el.focus()
      }
    }
  }
}
</script>

<style lang="scss">
.definition-wrapper.text {
  word-break: break-all;

  input.w3-input {
    border-radius: 2px;
    background-color: #ffffff;
    border: solid 1px #e8e8e8;
    height: 33px;
    outline: none;
    width: 100%;
  }
  input.w3-input:focus {
    border: solid 1px #b8b8b8;
  }
  textarea {
    resize: vertical;
    min-height: 94px;
    border: 1px solid #ccc;
  }
  .js-code {
    .js-code-toolbar {
      text-align: right;
      margin-bottom: 4px;
    }
    .js-code-format-btn {
      cursor: pointer;
      border: 1px solid #5dbecd;
      background: #ffffff;
      color: #3a96a6;
      border-radius: 3px;
      padding: 2px 10px;
      font-size: 12px;
      line-height: 18px;
      transition: all 0.15s;
      i { margin-right: 3px; }
    }
    .js-code-format-btn:hover {
      background: #5dbecd;
      color: #ffffff;
    }
    .js-code-editor {
      border: 1px solid #ccc;
      border-radius: 2px;
      overflow: hidden;
      &.error_validate { border-color: #FF3654; }
      // Altura por defecto cómoda (~14 líneas); crece con el contenido hasta el
      // máximo y a partir de ahí scrollea el propio editor.
      .cm-editor {
        min-height: 280px;
        max-height: 600px;
      }
      .cm-scroller {
        overflow: auto;
        font-family: 'Menlo', 'Consolas', 'Monaco', monospace;
        font-size: 13px;
      }
      .cm-focused { outline: none; }
    }
  }
  .multilanguageText {
    float: left;
    width: calc(100% - 154px);
    position: relative;

    &.translation {
      width: calc(100% - 188px);
    }
  }
  .count {
    font-style: italic;
    font-weight: 400;
    margin-top: 2px;
    margin-bottom: 2px;
    padding: 0 2px 0 0;
    display: block;
    font-size: 9px;
    font-stretch: normal;
    line-height: 1.1;
    letter-spacing: normal;
    color: #bbb;
    position: absolute;
    right: 0;
  }
  .languageSelectorOrTask {
    float: right;

    .language {
      max-width: 188px;

      .multiselect {
        float: left;
        width: auto;

        .multiselect__tags {
          width: 154px;
        }
        .multiselect__tags,
        .multiselect__single,
        .multiselect__input {
          background-color: #efefef;
          font-size: 10px;
        }
      }
    }
  }
  .emoji-invoker {
    position: absolute;
    top: .45rem;
    right: 2.25rem;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s;
  }
  .emoji-invoker:hover,
  .emoji-invoker.active {
    transform: scale(1.15);
  }
  .emoji-invoker > svg {
    fill: #b1c6d0;
  }
  .validation_icon {
    position: absolute;
    right: 10px;
    top: 12px;
  }
}
.w3-center {
  input.w3-input {
    text-align: center;
  }
}
</style>
